import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { SubmissionError } from 'redux-form';
import { formatValidationErrors } from '../common/utils/getApiReducer';
import { selectActiveGolfSchool, selectActiveClass } from './selectors';
import { editClass, deleteClass } from './actions';

import Breadcrumb from '../common/components/Breadcrumb';
import ClassUserList from './ClassUserList';
import EditClassForm from './EditClassForm';
import formatClassDateRange from './formatClassDateRange';

class ClassPage extends Component {
  state = {
    editing: false,
  };

  toggleEdit = () => {
    this.setState(state => ({ editing: !state.editing }));
  };

  onDelete = () => {
    const { dispatch, match: { params: { schoolId, classId } } } = this.props;

    return dispatch(deleteClass(schoolId, classId)).then(() => {
      this.props.history.push(`/golf-schools/${schoolId}`);
    });
  };

  onEditClassSubmit = values => {
    const { dispatch, match: { params: { schoolId, classId } } } = this.props;

    return dispatch(editClass(schoolId, classId, values)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.setState(state => ({ editing: false }));
      }
    });
  };

  render() {
    const { activeGolfSchool, activeClass, location } = this.props;
    const { editing } = this.state;

    if (!activeGolfSchool || !activeClass) {
      return null;
    }

    const breadcrumbs = [
      {
        label: 'Golf Schools',
        to: '/golf-schools',
      },
      {
        label: activeGolfSchool.name,
        to: `/golf-schools/${activeGolfSchool.id}${location.search}`,
      },
      {
        label: formatClassDateRange(activeClass.start_date, activeGolfSchool.days),
        to: null,
      },
    ];

    return (
      <div className="admin-paper">
        <div className="admin-paper__header">
          <Breadcrumb crumbs={breadcrumbs} />
        </div>
        {editing ? (
          <EditClassForm
            class={activeClass}
            initialValues={{
              start_date: moment(activeClass.start_date),
              limit: activeClass.limit,
            }}
            onSubmit={this.onEditClassSubmit}
            onCancel={this.toggleEdit}
            onDelete={this.onDelete}
          />
        ) : (
          <div>
            <div className="admin-paper__edit-content">
              <div className="admin-paper__edit-content__row">
                <p>Dates</p>
                <span className="title">{formatClassDateRange(activeClass.start_date, activeGolfSchool.days)}</span>
              </div>
              <div className="admin-paper__edit-content__row">
                <p>Limit</p>
                <span>{activeClass.limit}</span>
              </div>
              <div className="admin-paper__edit-button">
                <button className="button" onClick={this.toggleEdit}>
                  Edit
                </button>
              </div>
            </div>
            <ClassUserList activeClass={activeClass} />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  return {
    activeGolfSchool: selectActiveGolfSchool(state, ownProps.match.params.schoolId),
    activeClass: selectActiveClass(state, ownProps.match.params.classId),
  };
})(ClassPage);



// WEBPACK FOOTER //
// ./src/golf-schools/ClassPage.js